import React from 'react';
import { ShoppingCart } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { toast } from 'sonner';
import { ImageCarousel } from './ImageCarousel';

export const ProductCard = ({ product }) => {
  const navigate = useNavigate();
  const { addToCart } = useCart();

  const handleAddToCart = (e) => {
    e.stopPropagation();
    addToCart(product);
    toast.success(`${product.name} agregado al carrito`);
  };

  return (
    <div
      onClick={() => navigate(`/products/${product.id}`)}
      className="bg-white rounded-3xl border border-slate-100 overflow-hidden hover:shadow-xl transition-all duration-300 group cursor-pointer"
      data-testid={`product-card-${product.id}`}
    >
      <div className="relative overflow-hidden aspect-square">
        <ImageCarousel 
          images={product.images && product.images.length > 0 ? product.images : [product.imageUrl]} 
          altText={product.name}
          className="group-hover:scale-105 transition-transform duration-300"
        />
        {product.featured && (
          <div className="absolute top-4 right-4 bg-[#FFD700] text-[#3D2E00] px-3 py-1 rounded-full font-fredoka font-bold text-sm">
            Destacado
          </div>
        )}
        {product.stock <= 0 && (
          <div className="absolute inset-0 bg-black/50 flex items-center justify-center">
            <span className="bg-red-500 text-white px-4 py-2 rounded-full font-fredoka font-bold">
              Agotado
            </span>
          </div>
        )}
      </div>
      <div className="p-6">
        <h3 className="font-fredoka font-bold text-xl text-[#1A1A2E] mb-2" data-testid={`product-name-${product.id}`}>
          {product.name}
        </h3>
        <p className="text-[#4A4A6A] font-quicksand text-sm mb-4 line-clamp-2">
          {product.description}
        </p>
        <div className="flex items-center justify-between">
          <span className="text-2xl font-fredoka font-bold text-[#00C2CB]" data-testid={`product-price-${product.id}`}>
            ${product.price.toLocaleString()}
          </span>
          <button
            onClick={handleAddToCart}
            disabled={product.stock <= 0}
            className="bg-[#FF6B00] text-white px-4 py-2 rounded-full font-quicksand font-semibold hover:bg-[#FF6B00]/90 hover:scale-105 transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:scale-100"
            data-testid={`add-to-cart-button-${product.id}`}
          >
            <ShoppingCart className="w-5 h-5" />
          </button>
        </div>
        {product.stock > 0 && product.stock <= 5 && (
          <p className="text-xs text-orange-500 mt-2 font-quicksand">
            ¡Solo quedan {product.stock} unidades!
          </p>
        )}
      </div>
    </div>
  );
};